import { Divider, Drawer, Input, Space, Slider, Checkbox, Tooltip } from "antd";
import React, { useState } from "react";
import EditorPanelHeading from "../../UI/EditorPanelHeading";
import PresetPicker from "../../../globals/styles/PresetPicker";
import BMInput from "../../comps/BMInput";
import { PicRightOutlined, PicLeftOutlined, PicCenterOutlined } from '@ant-design/icons';
import ColourPicker from "../../../globals/styles/ColourPicker";
import { getColor } from "../../../utils/ConvertCSS";
import { useTemplate } from "../../../utils/Template";
import { AlignCenterIcon, AlignLeftIcon, AlignRightIcon, PaddingHorizontalIcon, PaddingVerticalIcon } from "../../Icons";
import Html from "../../../utils/Html";
import RichTextEditor from "../../UI/RichTextEditor";
import TitlePicker from "../../UI/TitlePicker";
import { tt_name_block_warning, tt_stf_padding_x, tt_stf_padding_y, tt_stf_txt_padding_x, tt_stf_txt_padding_y } from "../../../utils/Utils";
import SliderInput from "../../UI/SiderInput";
import LinkPicker from "../../../globals/styles/LinkPicker";
export default function SingleTitleFeature(props) {

    const { edit = false, close = () => { }, saveItem = () => { }, deleteItem = () => { }, id = 0 } = props;
    const [template, ] = useTemplate();
    const [l, setL] = useState(false)
    const [r, setR] = useState(false);
    const [w, setW] = useState(false);
    const [content, setContent] = useState(props.content);

    const setData = (_data) => {
        setContent({ ...content, "data": _data })
    }

    const isObjectWithKey = (obj, key) => {
        // Check if obj is an object
        if (typeof obj !== 'object' || obj === null) {
            return false;
        }
        // Check if key is a string
        if (typeof key !== 'string' || key.length === 0) {
            return false;
        }
        // Check if the key exists in the object
        return key in obj;
    }

    // Component agnostic
    const {
        name = "",
        container = true,
        data = {},
        date_changed = 0,
    } = content;

    // Jesus, no idea why this is needed.. 
    const props_injected = isObjectWithKey(props.content.injected_data, "eisbn") ? props.content.injected_data : {}
    const [injected, setInjected] = useState(props_injected);

    const {
        title = "",
        eisbn = "",
        cover_image_cache = "",
        authors = [],
        description = "",
        bio = []

    } = edit ? injected : props_injected;

    // Component specific
    const {
        isbn = "",
        padding_x = 10,
        padding_y = 10,
        flip = true,
        background_colour = 0,
        image_width = 20,
        text_width = 100,
        text_padding_x = 15,
        text_padding_y = 0,
        text_align = "left",
        align = "0",
        title_preset = 0,
        author_preset = 0,
        bio_preset = 0,
        description_preset = 0,
        title_text = "Title...",
        author_text = "Author...",
        bio_text = "Bio...",
        description_text = "Description...",
        use_title = true,
        use_author = true,
        use_bio = true,
        use_description = true,
        constrain_container = false,
        container_width = 1248,
        link_id = 0,
    } = data;

    const save = () => {
        if (!name) {
            let _name = prompt(tt_name_block_warning);
            if (_name) {
                close();
                saveItem(id, { ...content, "name": _name });
            } else {
                return;
            }
        } else {
            close();
            saveItem(id, { ...content })
        }
    }

    const trash = () => {
        deleteItem(id);
        close();
    }

    const parseAuthors = (_authors) => {
        return _authors.map(item => item.name).join(", ");
    }

    const parseBios = (_bios) => {
        return _bios.join("<br /><br />");
    }

    const drawRender = () => {
        let _style = {
            padding: text_padding_y + "px " + text_padding_x + "px",
            maxWidth: (1248 * (text_width / 100)) + "px",
            width: "100%",
            alignSelf: "flex-start",
            textAlign: text_align,
            border: (r) ? "4px solid deeppink" : "none"
        }

        let containerStyle = {
            padding: padding_y + "px " + padding_x + "px",
            background: getColor(background_colour, template),
            maxWidth: (constrain_container) ? container_width + "px" : "100%",
            border: (w) ? "4px solid deeppink" : "none",
            margin: align,
        }

        let _stack = (flip) ? "row" : "row-reverse";

        if (props.view === "phone") {
            _stack = (flip) ? "column" : "column-reverse"
        }

        return (
            <div id={"bm-" + id} className={(container) ? "preview-container" : ""}>
                <div style={containerStyle}>
                    <div style={{ display: 'flex', width: '100%', flexDirection: _stack }}>
                        <div style={{ flex: '0 0 ' + image_width + "%", border: (l) ? "4px solid deeppink" : "none" }}>
                            {(eisbn) ? <img style={{ "width": "100%" }} src={"https://cdn1.bookmanager.com/i/m?b=" + eisbn + "&cb=" + cover_image_cache} /> : <img style={{ "width": "100%" }} src={"https://bookmanager.com/i/sample_content/placeholder.jpg"} />}
                        </div>
                        <div style={{ flex: '0 0 ' + (100 - image_width) + "%", display: 'flex' }}>
                            <div style={_style}>
                                <h3 style={{ "display": "block" }} className={"bm-txt-" + title_preset} >
                                    {(use_title) ? title : title_text}
                                </h3>
                                <div style={{ "display": "block" }} className={"bm-txt-" + author_preset} >
                                    {(use_author) ? parseAuthors(authors) : author_text}
                                </div>
                                <Divider style={{ "margin": "15px 0px" }} />
                                <div className={"bm-txt-" + description_preset} >
                                    {(use_description) ? <><Html anchor={"bm-lnkin-" + link_id} html={description} />{(description && <br />)}</> : <><Html anchor={"bm-lnkin-" + link_id} html={description_text} />{(description_text && <br />)}</>}
                                </div>
                                <div className={"bm-txt-" + bio_preset} >
                                    
                                    {(use_bio) ? <Html anchor={"bm-lnkin-" + link_id} html={parseBios(bio)} /> : <Html anchor={"bm-lnkin-" + link_id} html={bio_text} />}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    const formatter = (value) => `${value}%`;

    const drawForm = () => {
        return (
            <>
                <EditorPanelHeading menus={props.menus} close={close} trash={trash} save={save} content={content} setContent={setContent} date_changed={date_changed} name={name} />
                {/* MAX WIDTH */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">MAX WIDTH</Divider>
                <div className="float-flex">
                    <SliderInput
                        onBeforeChange={() => setW(true)}
                        onAfterChange={() => setW(false)}
                        width={90}
                        min={0}
                        max={1248}
                        onChange={(_v) => setData({ ...data, "container_width": _v })}
                        disabled={!constrain_container}
                        value={container_width}
                    />
                    <Checkbox onChange={(e) => setData({ ...data, "constrain_container": e.target.checked })} checked={constrain_container}><small>Constrain?</small></Checkbox>
                </div>
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">ALIGN</Divider>
                <Space>
                    <div><PicLeftOutlined onClick={() => setData({ ...data, "align": "0" })} style={{ "color": (align === "0") ? "#1890ff" : "#AAA" }} /></div>
                    <div><PicCenterOutlined onClick={() => setData({ ...data, "align": "0 auto" })} style={{ "color": (align === "0 auto") ? "#1890ff" : "#AAA" }} /></div>
                    <div><PicRightOutlined onClick={() => setData({ ...data, "align": "0 0 0 auto" })} style={{ "color": (align === "0 0 0 auto") ? "#1890ff" : "#AAA" }} /></div>
                </Space>
                <div className="shim" /> <div className="shim" /> <div className="shim" />
                {/* Title */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">ISBN</Divider>
                <TitlePicker product={injected} setProduct={setInjected} value={isbn} onChange={(_v) => setData({ ...data, "isbn": _v })} />
                <div className="shim" /> <div className="shim" /> <div className="shim" />
                {/* use_title_data */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">USE TITLE DATA?</Divider>
                <Space size={0}>
                    <Checkbox checked={use_title} onChange={(e) => setData({ ...data, "use_title": e.target.checked })}><small>Title</small></Checkbox>
                    <Checkbox checked={use_author} onChange={(e) => setData({ ...data, "use_author": e.target.checked })}><small>Author</small></Checkbox>
                    <Checkbox checked={use_description} onChange={(e) => setData({ ...data, "use_description": e.target.checked })}><small>Description</small></Checkbox>
                    <Checkbox checked={use_bio} onChange={(e) => setData({ ...data, "use_bio": e.target.checked })}><small>Bios</small></Checkbox>
                </Space>
                <div style={{ "margin": "0px -25px" }}><Divider style={{ "margin": "15px 0px" }} /></div>
                {/* BACKGROUND COLOUR */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BACKGROUND COLOUR</Divider>
                <ColourPicker allow_gradient allow_none value={background_colour} onChange={(_v) => setData({ ...data, "background_colour": _v })} />
                <div className="shim" /> <div className="shim" /><div className="shim" />
                {/* PADDING FLIP */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">PADDING / FLIP</Divider>
                <div className="float-flex">
                    <div>
                        <Space>
                            <BMInput value={padding_x} onChange={(_v) => setData({ ...data, "padding_x": _v })} number min={0} max={100} prefix={<Tooltip title={tt_stf_padding_x}><PaddingHorizontalIcon style={{ "color": "#888" }} /></Tooltip>} />
                            <BMInput value={padding_y} onChange={(_v) => setData({ ...data, "padding_y": _v })} number min={0} max={100} prefix={<Tooltip title={tt_stf_padding_y}><PaddingVerticalIcon style={{ "color": "#888" }} /></Tooltip>} />
                        </Space>
                    </div>
                    <Checkbox checked={flip} onChange={(e) => setData({ ...data, "flip": e.target.checked })}><small>Flip</small></Checkbox>
                </div>
                <div style={{ "margin": "0px -25px" }}><Divider style={{ "margin": "15px 0px" }} /></div>
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">IMAGE WIDTH</Divider>
                <Slider
                    onBeforeChange={() => setL(true)}
                    onAfterChange={() => setL(false)}
                    tooltip={{
                        formatter,
                    }}
                    style={{ "width": "100%" }}
                    min={0}
                    max={50}
                    onChange={(_v) => setData({ ...data, "image_width": _v })}
                    value={image_width}
                />
                <div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">TEXT WIDTH / POSITION</Divider>
                <div className="float-flex">
                    <Slider
                        onBeforeChange={() => setR(true)}
                        onAfterChange={() => setR(false)}
                        style={{ "width": "100%" }}
                        tooltip={{
                            formatter,
                        }}
                        min={0}
                        max={100}
                        onChange={(_v) => setData({ ...data, "text_width": _v })}
                        value={text_width}
                    />
                </div>
                <div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">TEXT ALIGN / PADDING</Divider>
                <div className="float-flex">
                    <div>
                        <Space>
                            <div><AlignLeftIcon onClick={() => setData({ ...data, "text_align": "left" })} style={{ "color": (text_align === "left") ? "#1890ff" : "#AAA" }} /></div>
                            <div><AlignCenterIcon onClick={() => setData({ ...data, "text_align": "center" })} style={{ "color": (text_align === "center") ? "#1890ff" : "#AAA" }} /></div>
                            <div><AlignRightIcon onClick={() => setData({ ...data, "text_align": "right" })} style={{ "color": (text_align === "right") ? "#1890ff" : "#AAA" }} /></div>
                        </Space>
                    </div>
                    <Space>
                        <BMInput value={text_padding_x} onChange={(_v) => setData({ ...data, "text_padding_x": _v })} number min={0} max={100} prefix={<Tooltip showArrow={false} title={tt_stf_txt_padding_x}><PaddingHorizontalIcon style={{ "color": "#888" }} /></Tooltip>} />
                        <BMInput value={text_padding_y} onChange={(_v) => setData({ ...data, "text_padding_y": _v })} number min={0} max={100} prefix={<Tooltip showArrow={false} title={tt_stf_txt_padding_y}><PaddingVerticalIcon style={{ "color": "#888" }} /></Tooltip>} />
                    </Space>
                </div>
                <div className="shim" /> <div className="shim" />
                <div className="group-wrap">
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">TITLE PRESET</Divider>
                    <PresetPicker value={title_preset} onChange={(e) => setData({ ...data, "title_preset": e })} />
                    <div className="shim" /> <div className="shim" />
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">TITLE</Divider>
                    <Input disabled={(use_title)} style={{ "fontSize": "11px" }} onChange={(e) => setData({ ...data, "title_text": e.target.value })} value={title_text} placeholder="Title..." />
                </div>
                <div className="shim" /> <div className="shim" />
                <div className="group-wrap">
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">AUTHOR PRESET</Divider>
                    <PresetPicker value={author_preset} onChange={(e) => setData({ ...data, "author_preset": e })} />
                    <div className="shim" /> <div className="shim" />
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">AUTHOR</Divider>
                    <Input disabled={(use_author)} style={{ "fontSize": "11px" }} onChange={(e) => setData({ ...data, "author_text": e.target.value })} value={author_text} placeholder="Author..." />
                </div>
                <div className="shim" /> <div className="shim" />
                <div className="group-wrap">
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">DESCRIPTION PRESET</Divider>
                    <PresetPicker value={description_preset} onChange={(e) => setData({ ...data, "description_preset": e })} />
                    <div className="shim" /> <div className="shim" />
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">DESCRIPTION</Divider>
                    <RichTextEditor container={container} link_id={link_id} background_colour={background_colour} disabled={(use_description)} padding_x={padding_x} padding_y={padding_y} paragraph_preset={description_preset} text_align={text_align} width={(1248 * (text_width / 100))} value={description_text} onChange={(_v) => setData({ ...data, "description_text": _v })} />
                </div>
                <div className="shim" /> <div className="shim" />
                <div className="group-wrap">
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BIO PRESET</Divider>
                    <PresetPicker value={bio_preset} onChange={(e) => setData({ ...data, "bio_preset": e })} />
                    <div className="shim" /> <div className="shim" />
                    <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BIO</Divider>
                    <RichTextEditor container={container} link_id={link_id} background_colour={background_colour} disabled={(use_bio)} padding_x={padding_x} padding_y={padding_y} paragraph_preset={bio_preset} text_align={text_align} width={(1248 * (text_width / 100))} value={bio_text} onChange={(_v) => setData({ ...data, "bio_text": _v })} />
                    {/* <ParagraphUI value={paragraph} onChange={(_v) => setData({...data, "paragraph" : _v})} /> */}
                </div><div className="shim" /> <div className="shim" />

                {/* LINK STYLE */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">LINK STYLE</Divider>
                <LinkPicker value={link_id} onChange={(e) => setData({ ...data, "link_id": e })} />
                <div className="shim" /> <div className="shim" />
            </>
        )
    }

    return (
        <>
            <Drawer bodyStyle={{ "backgroundColor": "#f5f5f5", "overflowX": "hidden" }} closable={false} width={300} onClose={() => close(true)} open={edit}>
                {drawForm()}
            </Drawer>
            {drawRender()}
        </>
    )
}